import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSesion } from './useSesion';
import { RUTA_ACCESO } from '../rutas';

/**
 * Deja pasar a `/inversionistas/*` sólo con sesión; si no, manda al acceso.
 *
 * **Espera a que la rehidratación termine antes de decidir.** Sin eso, el
 * primer render de una recarga dice «no hay sesión» —porque leer el
 * almacenamiento es asíncrono— y esta ruta manda al acceso a alguien que sí la
 * tiene. No es un parpadeo: la URL cambia, y el sitio donde estaba se pierde.
 * Es de los fallos que no se ven navegando y sólo aparecen al recargar una ruta
 * profunda o al abrir un enlace guardado.
 *
 * **Y lo que este guardia NO es:** una protección del contenido. El bundle es
 * el mismo para todo el mundo, así que lo que viaja dentro lo lee quien
 * insista, con sesión o sin ella. Lo que esto hace es que la aplicación tenga
 * una puerta; cerrar el contenido de verdad es que las cifras vengan del
 * servidor contra un token, y eso es otra fase.
 */
export function GuardiaDeSesion() {
  const { sesion, rehidratando } = useSesion();
  const ubicacion = useLocation();

  // `null` y no un spinner: la rehidratación dura lo que tarda una lectura de
  // `localStorage`. Un indicador que aparece y desaparece en el mismo cuadro se
  // ve como un fallo de pintado, no como una espera.
  if (rehidratando) return null;

  if (!sesion) {
    // `state.from` deja volver a donde iba después de entrar. `replace` para
    // que el botón de atrás no lo devuelva a una ruta que va a rebotar otra vez.
    return <Navigate to={RUTA_ACCESO} replace state={{ from: ubicacion.pathname }} />;
  }

  return <Outlet />;
}
